import { useContext } from 'react';

import MetricOptionsContext from '../contexts/MetricOptionsContext';

const useMetric = (metricId?: string) => {
  const { metricOptionsLookup } = useContext(MetricOptionsContext);

  if (!metricId) {
    return undefined;
  }

  return metricOptionsLookup[metricId];
};

export default useMetric;
